// Task #1018 — Shared helpers for the `?ct=...&fn=...` URL annotations
// the messaging UI uses to preserve a human-chosen filename on
// attachment URLs. Used by the staff composer (`new-message-modal.tsx`,
// `app-messages.tsx` reply path) and consumed by `message-attachments.tsx`'s
// `parseAttachment` / `downloadFileNameFor`.
//
// Mirrors `server/lib/attachment-url.ts` so a defense-in-depth pass on
// either side produces the same sanitized result.

const FILENAME_MAX_LEN = 200;

export function sanitizeOriginalName(raw: string): string | null {
  if (typeof raw !== "string") return null;
  const last = raw.replace(/\\/g, "/").split("/").pop() || "";
  // eslint-disable-next-line no-control-regex
  const cleaned = last.replace(/[\x00-\x1f\x7f]/g, "").trim();
  if (!cleaned) return null;
  return cleaned.length > FILENAME_MAX_LEN ? cleaned.slice(0, FILENAME_MAX_LEN) : cleaned;
}

// Annotate an `/objects/<entityId>` path (or any URL) with `?fn=<filename>`
// so the recipient's lightbox Download saves the file with its original
// chosen name instead of the storage UUID. The server's
// `sanitizeMessageAttachmentUrls` will read and re-emit this annotation
// alongside its own `?ct=...` content-type marker.
export function annotateAttachmentUrl(
  objectPath: string,
  filename: string | null | undefined,
): string {
  const cleaned = sanitizeOriginalName(typeof filename === "string" ? filename : "");
  if (!cleaned) return objectPath;
  const sep = objectPath.includes("?") ? "&" : "?";
  return `${objectPath}${sep}fn=${encodeURIComponent(cleaned)}`;
}
